<template>
  <div class="consultar-orcamentos">
    <g-card class="card-consultar-orcamentos" :expansivel="true" :comecaFechado="false">
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Consultar Orçamentos </div>
          <div class="header-icons">
            <g-button
            class="trash-box"
            tipo="cinza"
            altura="35px"
            largura="45px"
            icone="icone_lixo.svg"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            v-tooltip="'Limpar filtro'"
            @click="limparFiltro"
            />
            <g-button
            class="buscar-button-header-filtro"
            largura="150px"
            icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="15px"
            altura="35px"
            gap="10px"
            :sombreado="false"
            @click="Grid()"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="consultar-orcamentos-conteudo espacamento-filtros">
          <div class="unidade">
            <div class="unidade-titulo titulo-conteudo-filtros"> Unidade</div>
            <PDropDown
            class="unidade-input input-label"
            placeholder="TODAS"
            :filter="true"
            optionLabel="nome"
            optionValue="id"
            :options="EmpresaArray"
            v-model="objFiltro.EmpresaId"
            >
            </PDropDown>
          </div>
          <div class="cliente">
            <div class="cliente-titulo titulo-conteudo-filtros"> Cliente </div>
            <!-- <PDropDown
            class="cliente-input input-label"
            placeholder="Selecione o cliente"
            :filter="true"
            :filterFields="['razaoSocial','codigoExterno','nomeFantasia','situacao','estadoCidade','cnpj']"
            optionLabel="nomeFantasia"
            optionValue="id"
            :options="ClienteArray"
            v-model="objFiltro.ClienteId"
            @filter="buscarClientes($event.value)"
            >
              <template #option="slotProps">
                <cliente-dropdown-item :dadosCliente="slotProps.option"></cliente-dropdown-item>
              </template>
            </PDropDown> -->

            <cliente-dropdown 
            class="cliente-input input-label"
            v-model="objFiltro.ClienteId"
            :empresaId="objFiltro.EmpresaId"
            :representanteId="this.$store.state.representanteSelecionadoId"
            />
          </div>

          <div class="numero-solicitacao">
            <div class="numero-solicitacao-titulo titulo-conteudo-filtros"> Número da Solicitação </div>
            <PInputText
            class="numero-solicitacao-input input-label"
            placeholder="Insira o nº da Solicitação"
            v-model="objFiltro.NumeroSolicitacao"
            />
          </div>

          <div class="linha-producao">
            <div class="linha-producao-titulo titulo-conteudo-filtros"> Linha de Produção </div>
            <PDropDown
            class="linha-producao-input input-label"
            placeholder="Selecione"
            :filter="true"
            v-model="objFiltro.LinhaProduto"
            :options="LinhaProdutoArray"
            optionLabel="nomeLinha"
            optionValue="nomeLinha"
            v-on:blur="habilitarbotao"
            />
          </div>

          <div class="periodo-baixa">
            <div class="periodo-baixa-titulo titulo-conteudo-filtros"> Período de Baixa </div>
            <div class="input-data">
              <div class="data-inicio">
                <g-date-input
                class="periodo-baixa-inicio-input input-label"
                placeholderinput="Início"
                alturainput = "40px"
                largurainput = "100%"
                tamanhobotao = "35px"
                permiteDataPassadas
                dataPassadas
                invertido
                v-model="objFiltro.PeriodoDeBaixaInicio"
                ></g-date-input>
              </div>
              <div class="data-periodo"> à </div>
              <div class="data-termino">
                <g-date-input
                class="periodo-baixa-termino-input input-label"
                placeholderinput="Término"
                alturainput = "40px"
                largurainput = "100%"
                tamanhobotao = "35px"
                permiteDataPassadas
                dataPassadas
                invertido
                v-model="objFiltro.PeriodoDeBaixaFim"
                ></g-date-input>
              </div>
            </div>
          </div>

          <div class="periodo-emissao">
            <div class="periodo-emissao-titulo titulo-conteudo-filtros"> Período de Emissão </div>
            <div class="input-data">
              <div class="data-inicio">
                <g-date-input
                class="periodo-emissao-inicio-input input-label"
                placeholderinput="Início"
                alturainput = "40px"
                largurainput = "100%"
                tamanhobotao = "35px"
                permiteDataPassadas
                dataPassadas
                invertido
                v-model="objFiltro.PeriodoDeEmissaoInicio"
                ></g-date-input>
              </div>
              <div class="data-periodo"> à </div>
              <div class="data-termino">
                <g-date-input
                class="periodo-emissao-termino-input input-label"
                placeholderinput="Término"
                alturainput = "40px"
                largurainput = "100%"
                tamanhobotao = "35px"
                permiteDataPassadas
                dataPassadas
                invertido
                v-model="objFiltro.PeriodoDeEmissaoFim"
                ></g-date-input>
              </div>
            </div>
          </div>

          <div class="produto-novo">
            <div class="produto-novo-titulo titulo-conteudo-filtros"> Produto Novo </div>
            <PInputText
              class="produto-novo-input input-label"
              v-model="objFiltro.NomeProdutoNovo"
              placeholder="Insira o nome de produto"
              />
          </div>

          <div class="codigo-nome-produto">
            <!--<div class="codigo-produto">

               <PInputText
              class="codigo-produto-input input-label"
              placeholder="Código"
              v-model="objFiltro.CodigoProduto"
              />
            </div>-->

            <div class="nome-produto">
              <div class="codigo-produto-titulo titulo-conteudo-filtros"> Produto </div>
              <PDropDown
              class="nome-produto-input input-label"
              v-model="objFiltro.NomeProduto"
              placeholder="Insira o nome do produto"
              optionLabel="labelProduto"
              optionValue="produtoId"
              @filter="getProduto($event.value)"
              :filter="true"
              :options="ProdutoArray"
              />
            </div>
          </div>

          <div class="status">
            <div class="status-titulo titulo-conteudo-filtros"> Status </div>
            <PDropDown
            class="status-input input-label"
            placeholder="Selecione"
            :filter="true"
            v-model="objFiltro.Status"
            :options="statusArrayFront"
            optionLabel="text"
            optionValue="value"
            />
          </div>

          <!-- <div class="ordenacao">
            <div class="ordenacao-titulo titulo"> Ordenação </div>
            <PDropDown
              class="ordenacao-input input-label"
              :filter="true"
              optionLabel="nomeCidade"
              placeholder="Selecione a ordenação"
              v-model="objFiltro.Ordenacao"
            ></PDropDown>
          </div> -->
        </div>
      </g-form>

      <div class="buscar-button-filtro">
        <g-button
        class="buscar-button"
        largura="300px"
        icone="icone_lupa.svg"
        negritoTexto
        tamanhoIcone="15px"
        tamanhoTexto="15px"
        altura="35px"
        gap="10px"
        :sombreado="false"
        @click="Grid()"
        >
        BUSCAR
        </g-button>
      </div>
    </g-card>

    <g-card v-if="pt1" paddingDefault="1em 0 3em" :temCabecalho="false">
      <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg" />
      <div class="texto-padrao-imagemfundo">
        Verifique os filtros e clique em buscar para exibir os resultados
      </div>
    </g-card>

    <g-card v-else-if="!pt1" paddingDefault="0em 0 3em" :temCabecalho="false">
      <g-data-table
      TextoVazio="Nenhum orçamento Encontrado"
      Titulo="Orçamentos"
      altura="auto"
      :numeroBotoesAcao="6"
      v-on:clickprancheta="OpenModalCance"
      :colunas="Colunas"
      :valores="OrcamentoArray"
      :Paginacao="true"
      :NumeroLinhas="100"
      :FiltrosEspecificos="true"
      :Editavel="false"

      :checkprancheta="true"
      TextoPrancheta="Dar Baixa no Orçamento"
      :Copiavel="true"
      :rowEditor="true"
      :Reorcavel="listaPermitidos"

      :OrcamentoQuantidade="true"
      :Filtros="Filtro"
      v-on:clickCopiar="copiarPopUp"
      v-on:duploClickLinha="detalhesOrcamento"
      v-on:abrePopup="copiarPopUpReorcamento"
      v-on:abreQuantidade="copiarPopUpOrcamentoQuantidade"
      v-on:clickImprimir="imprimir"
      v-on:downloadPDF="download"
      :campoAgrupador="'empresaCliente'"
      :campoExibicaoGrupo="'empresaCliente'"
      ></g-data-table>
    </g-card>

    <PDialog :showHeader="false" :closable="false" v-model:visible="popup" :modal="true">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Deseja criar um novo orçamento com as mesmas informações? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="fecharpopup"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="criarCopiaDeOrcamento"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>

    <PDialog :showHeader="false" :closable="false" v-model:visible="popupReorcamento" :modal="true">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Deseja fazer um reorçamento? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click.once="fecharpopup"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click.once="criarReorcamento"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>

    <PDialog :showHeader="false" :closable="false" v-model:visible="popupOrcamentoQuantidade" :modal="true">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Deseja criar uma nova opção de quantidade do orçamento? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="fecharpopup"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="criarOrcamentoQuantidade"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>

    <PDialog :showHeader="false" :closable="false" v-model:visible="popupAviso" :modal="true">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Deseja dar baixa no orçamento? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="fecharpopupsair"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="nextFase"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>

    <PDialog :showHeader="false" :closable="false" v-model:visible="popupPedidoAtivo" :modal="true">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Atenção! Existe um pedido #{{ codigoPedidoArray.codigoExterno }} em digitação para esta solicitação de orçamento. Excluir primeiro este item antes de baixar a solicitação</div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="fecharpopupPedidoAtivo"
          >
            FECHAR
          </g-button>
        </div>
      </div>
    </PDialog>

    <PDialog id="popup-motivo-baixa" :closable="false" v-model:visible="popupCancelarOrcamento" >
      <template #header>
        <div class="cabecalho-popup-motivo-baixa">
          <div class="titulo-popup-motivo-baixa"> BAIXA / DISPOSIÇÃO </div>
          <div class="subtitulo-popup-motivo-baixa"> Descreva sobre o processo de baixa do orçamento </div>
        </div>
      </template>

      <div class="conteudo-popup-motivo-baixa">
        <div class="motivo">
          <div :class="`motivo-pt1 ${motivoBaixa !== 0 ? 'motivo-preco' : ''}`">
            <div class="titulo"> Motivo </div>
            <PDropDown
            class="motivo-input input-label"
            placeholder="Selecione"
            v-model="motivoBaixa"
            :options="MotivoBaixaArray"
            @change="limpaCampoPorcentagem"
            optionLabel="text" optionValue="value" :filter="true">
            </PDropDown>
          </div>
          <div :class="`motivo-pt2 ${motivoBaixa !== 0 ? 'invisivel' : ''}`">
            <div class="titulo"> % </div>
            <PInputText 
              v-mask="'##.##'"
              :max="9999"
              v-model="porcentagem"
            />
          </div>
        </div>

        <div class="concorrente">
          <div class="titulo"> Concorrente </div>
          <PDropDown
          class="concorrente-input input-label"
          placeholder="Selecione"
          v-model="concorrenteId"
          :options="ConcorrenteArray"
          :disabled="motivoBaixa !== 0 && motivoBaixa !== 1"
          optionLabel="nomeConcorrente" optionValue="id" :filter="true">
          </PDropDown>
        </div>
      </div>

      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          class="botao-cancelar"
          largura="200px"
          textoFontWeight="500"
          @click="fecharpopupsair"
          >
            CANCELAR
          </g-button>
        </div>
        <div>
          <g-button
          tipo="amarelo"
          class="botao-informar"
          largura="200px"
          textoFontWeight="500"
          @click.once="setMotivoBaixarOrcamento"
          >
            INFORMAR MOTIVO
          </g-button>
        </div>
      </div>
    </PDialog>
    </div>

    <!-- pdf visualização clicando no botão de imprimir -->
    <div v-if="pdfvisualizacao">
      <g-pdf :pdfFloat="false" :NovaGuia="true"  :executar="executarvisualizacao">
        <div>
          <div class="container-logo">
            <img class="logo-login" src="@/assets/imgs/grupo_jauense_logo.svg">
          </div>
        </div>
        <div class="render" v-if="renderiza">
          <ConsultarOrcamentoPDF :PropstyleImg= "this.styleImg" :PropcaminhoImagem="this.caminhoImagem" :tituloDetalhes="false" v-on:termino="gerarPdf" :orcamentoId="orcamentoSelecionado"></ConsultarOrcamentoPDF>
        </div>
      </g-pdf>
    </div>

    <!-- download de pdf direto sem visualização -->
    <div v-if="!pdfvisualizacao">
      <g-pdf :nomeArquivo="`Orcamento-${this.nomeCliente}`" :pdfFloat="false" :NovaGuia="false"  :executar="executardownload" >
        <div>
          <div class="container-logo">
            <img class="logo-login" src="@/assets/imgs/grupo_jauense_logo.svg">
          </div>
        </div>
        <div class="render" v-if="renderizadownload">
          <OrcamentoInformacao :tituloDetalhes="false" v-on:termino="downloadPdf" :orcamentoId="orcamentoSelecionado"></OrcamentoInformacao>
        </div>
      </g-pdf>
    </div>
</template>


<script>
import ConsultarOrcamento from './ConsultarOrcamento.js'
export default ConsultarOrcamento
</script>

<style scoped>
.invisivel {
  display: none;
}
.motivo-preco{
  width: 65%;
}
.motivo{
  display: flex;
  gap: 10px;
}
.motivo-pt1{
  width: 100%;
}
.motivo-pt2{
  width: 35%;
}
.container-logo{
  padding: 30px 30px 10px 53px;
}
.cabecalho-popup-motivo-baixa {
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}
.titulo-popup-motivo-baixa {
  color: #3e3e3e;
  text-align: center;
  font-size: 18px;
  font-family: "MontSerrat";
  font-weight: bold;
}
.subtitulo-popup-motivo-baixa {
  text-align: center;
}

.titulo {
  color: #4F2C19;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: 700;
  margin-top: 15px;
}

@media (min-width:310px) {
.cabecalho-popup-motivo-baixa {
  display: flex;
  flex-direction: column;
}

.conteudo-popup-motivo-baixa {
  margin-bottom: 45px;
}
}
@media (min-width: 600px) {
.consultar-orcamentos-conteudo {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(6, auto);
  grid-column-gap: 20px;
}

.unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente { grid-area: 1 / 2 / 2 / 3; }
.numero-solicitaao { grid-area: 2 / 1 / 3 / 2; }
.linha-producao { grid-area: 2 / 2 / 3 / 3; }
.periodo-baixa { grid-area: 3 / 1 / 4 / 2; }
.periodo-emissao { grid-area: 3 / 2 / 4 / 3; }
.produto-novo { grid-area: 4 / 1 / 5 / 3; }
.codigo-nome-produto { grid-area: 5 / 1 / 6 / 3; }
.status { grid-area: 6 / 1 / 7 / 3; }
}

@media (min-width:650px) {
.popups-consultar-orcamentos {
  width: 26em;
}
}

@media (min-width: 801px) {
.consultar-orcamentos-conteudo {
  grid-template-rows: repeat(5, auto);
}

.periodo-baixa { grid-area: 3 / 1 / 4 / 2; }
.periodo-emissao { grid-area: 3 / 2 / 4 / 3; }
.produto-novo { grid-area: 4 / 1 / 5 / 2; }
.codigo-nome-produto { grid-area: 4 / 2 / 5 / 3; }
.status { grid-area: 5 / 1 / 6 / 2; }
}

@media (min-width:1025px) {
.consultar-orcamentos-conteudo {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, auto);
}

.numero-solicitaao { grid-area: 1 / 3 / 2 / 4; }
.linha-producao { grid-area: 2 / 1 / 3 / 2; }
.periodo-baixa { grid-area: 2 / 2 / 3 / 3; }
.periodo-emissao { grid-area: 2 / 3 / 3 / 4; }
.produto-novo { grid-area: 3 / 1 / 4 / 2; }
.codigo-nome-produto { grid-area: 3 / 2 / 4 / 3; }
.status { grid-area: 3 / 3 / 4 / 4; }
}

@media (min-width: 1500px) {
.consultar-orcamentos-conteudo {
  grid-template-columns: repeat(4, 1fr);
}

.linha-producao { grid-area: 1 / 4 / 2 / 5; }
.periodo-baixa { grid-area: 2 / 1 / 3 / 2; }
.periodo-emissao { grid-area: 2 / 2 / 3 / 3; }
.produto-novo { grid-area: 2 / 3 / 3 / 4; }
.codigo-nome-produto { grid-area: 2 / 4 / 3 / 5; }
.status { grid-area: 3 / 1 / 4 / 2; }
}
</style>